import { DropdownProps } from './dropdown.props';

export const DropdownPresets: DropdownProps = {
  canShowDropdown: true,
  closeBehavior: 'automatic',
  opened: false,
};
